import { Component, inject } from '@angular/core';
import { DashboardSignInFacade } from 'src/app/facades/dashboard-sign-in.facade';

@Component({
	standalone: false,
	selector: 'app-sign-in',
	templateUrl: './sign-in.component.html',
	styleUrls: ['./sign-in.component.scss'],
	providers: [DashboardSignInFacade],
})
export class SignInComponent {
	protected readonly facade = inject(DashboardSignInFacade);

	async onContinueWithGoogleClick(): Promise<void> {
		await this.facade.signInWithGoogle();
	}
}
